import watch from "./watch.svelte"

export const generateKey = <D extends () => any | any[]>(deps: D) => {
  let key = $state({ value: 0 })

  watch.pre(deps, () => key.value++)

  return key
}
